export default __webpack_public_path__ + "static/media/banner-bg.b363b0ff.png";